import * as React from 'react';
import { useEffect, useState } from "react";

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import AppNavbar from '../components/AppNavbar';
import Header from '../components/Header';
import { Alert, CircularProgress  } from '@mui/material';
import SideMenu from '../components/SideMenu';
import AppTheme from '../shared-theme/AppTheme';
import axiosInstance from '../utils/axiosInstance';
import { useParams } from 'react-router-dom';
import TDPDetail from '../components/TDPDetail';

import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function TDPDetailPage(props) {
  const { tdp_id } = useParams();
  const [tdp, setTdp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTDP = async () => {
      try {
        const res = await axiosInstance.get(`/tdps/${encodeURIComponent(tdp_id)}`);
        setTdp(res.data?.tdp || null);
        setError('');
      } catch (err) {
        console.error('Error fetching TDP detail:', err);
        setError(err?.response?.data?.message || 'Unable to load this xTDP right now.');
      } finally {
        setLoading(false);
      }
    };
    fetchTDP();
  }, [tdp_id]);

  const handleTdpUpdated = (updatedTdp) => {
    setTdp(updatedTdp);
  };

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Header breadcrumbItems={[
            {label: 'AMX xConsole', href: '/'},
            {label: 'xTDP', href: '/x-tdp'},
            {label: tdp ? (tdp.name || tdp.tdp_title) : 'Loading...'}
          ]}/>
          {loading ? <CircularProgress /> : null}
          {error ? <Alert severity="error">{error}</Alert> : null}
          {!loading && !error ? <TDPDetail tdp={tdp} onTdpUpdated={handleTdpUpdated} /> : null}
        </Box>
      </Box>
    </AppTheme>
  );
}
